import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

/**
 * markers: [{ lat, lng, color, label, radius }]
 * routes: arrays of [lat, lng] points (one polyline each)
 */
export default function MapView({ markers = [], routes = [], center = [12.9719, 77.5937], zoom = 12, height = 380, routeColor = "#0D9488", testid = "leaflet-map" }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    const map = L.map(elRef.current, { scrollWheelZoom: false }).setView(center, zoom);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors", maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
    layerRef.current = L.layerGroup().addTo(map);
    setTimeout(() => map.invalidateSize(), 150);
    return () => { map.remove(); mapRef.current = null; layerRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapRef.current, layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const bounds = [];
    (routes || []).forEach((r) => {
      const pts = (r || []).filter((p) => p && p[0] != null && p[1] != null);
      if (pts.length > 1) {
        L.polyline(pts, { color: "#ffffff", weight: 8, opacity: 0.9 }).addTo(layer);
        L.polyline(pts, { color: routeColor, weight: 4, opacity: 0.9 }).addTo(layer);
        pts.forEach((p) => bounds.push(p));
      }
    });
    (markers || []).filter((m) => m && m.lat != null && m.lng != null).forEach((m) => {
      const cm = L.circleMarker([m.lat, m.lng], {
        radius: m.radius || 9, color: "#fff", weight: 2, fillColor: m.color || "#0D9488", fillOpacity: 1,
      }).addTo(layer);
      if (m.label) { cm.bindPopup(m.label); cm.bindTooltip(m.label, { direction: "top", offset: [0, -8] }); }
      bounds.push([m.lat, m.lng]);
    });
    if (bounds.length) { try { map.fitBounds(bounds, { padding: [40, 40], maxZoom: 16 }); } catch {} }
    setTimeout(() => map.invalidateSize(), 150);
  }, [markers, routes, routeColor]);

  return <div ref={elRef} style={{ height }} className="w-full rounded-xl overflow-hidden border border-slate-200 relative z-0" data-testid={testid} />;
}
